import Grid from '@mui/material/Grid';
import TextCard from './TextCard';
import { useTheme } from "@mui/material";


export default function VariantLine({ marker, textcard, textcard_2, icon_1, icon_2}) {

  const theme = useTheme();
   
    return (

      theme.palette.mode === "light" ? (
     
      <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}> 
                   
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  {marker} </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   <TextCard textcard={textcard} /> </Grid> 
          <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   <TextCard textcard={textcard_2} /> </Grid> 
       
      </Grid>    
      
      ) : (

   
        <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%'}}> 
                   
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>  {marker} </Grid> 
        <Grid size={4}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   <TextCard textcard={textcard} /> </Grid> 
        <Grid size={3}  sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center',}}>   <TextCard textcard={textcard_2} /> </Grid> 
     
    </Grid>    

      )

    );
  }